import React from "react";
import Checkbox from "../Checkbox";
import Accordion from "../Accordion";
import OutputFactory from "../OutputFactory";
import CollapseView from "./CollapseView";
import AccordionProvider from "../Accordion/AccordionProvider";
import AccordionCollapse from "../Accordion/AccordionCollapse";
import htmlId from "../htmlId";

let timeoutId;

function Body({
                  objects,
                  fields,
                  columns,
                  excludes,
                  selected,
                  selectable,
                  onSelect,
                  onClick,
                  onLongPress,
                  actionsList,
                  collapsable,
                  onCollapse,
                  toggleable,
                  actions,
                  onClickItem,
                  fieldImage
              }) {
    const onPointerDown = () => {
        timeoutId = setTimeout(onLongPress, 500); // set long press time to 500ms
    };

    const onPointerUp = () => {
        clearTimeout(timeoutId);
    };
    return objects.map((object, index) => {
        const id = htmlId(object.id || object._id || index);
        const checked = selected.includes(object);
        return (<AccordionProvider
            key={id}>
            <tr>
                {selectable && (<th className="align-middle">
                    <Checkbox
                        checked={checked}
                        id={'check_' + id}
                        onChange={() => onSelect(index)}
                    />
                </th>)}

                {columns.map((field, i) => {
                    const options = fields[field];
                    if (excludes.includes(field)) return null;
                    return (<Accordion
                        as="td"
                        eventKey={`_${id}`}
                        key={field}
                        className="fs-sm text-truncate"
                        onPointerDown={onPointerDown}
                        onPointerUp={onPointerUp}
                        // onClick={() => onClick(index, field)}
                        style={{
                            cursor: 'pointer', maxWidth: '15em',
                        }}>
                        <OutputFactory
                            field={field}
                            object={object}
                            {...options}
                        />
                    </Accordion>);
                })}
                {actionsList.length > 0 && (<td>
                    <div style={{width: "50px"}}></div>
                </td>)}
                {actionsList.map((action) => {
                    return (<td
                        className="text-truncate">
                        <button
                            onClick={action.onClick && action.onClick.bind(this, index)}
                            className="btn btn-outline-primary btn-sm fs-xs shadow-none">
                            <i className={action.icon}/> {action.label}
                        </button>
                    </td>)
                })}
            </tr>
            {collapsable && (<tr>
                <td
                    className="p-0"
                    colSpan={columns.length + 1}>
                    <AccordionCollapse
                        toggleable={toggleable}
                        className="collapse p-3 "
                        eventKey={`_${id}`}>
                        {onCollapse(index, object, excludes) || CollapseView(index, object, excludes, fields, actions, onClickItem, fieldImage)}
                    </AccordionCollapse>
                </td>
            </tr>)}
        </AccordionProvider>);
    })
}

export default Body;